import { Card, CardContent } from '@/components/ui/card';
import { Headphones } from 'lucide-react';

export const InfluencerAudiobookTab = ({ audiobooks, backendUrl }) => (
  <div className="space-y-6">
    <h2 className="text-xl font-bold text-slate-900 flex items-center gap-2">
      <Headphones className="h-6 w-6 text-indigo-500" /> AudioBook - Estrategia e Marketing
    </h2>
    {audiobooks.length > 0 ? (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {audiobooks.map(ab => (
          <Card key={ab.audiobook_id} className="bg-white border border-slate-200 hover:shadow-md transition-shadow" data-testid={`audiobook-${ab.audiobook_id}`}>
            <CardContent className="pt-5">
              <div className="flex items-start gap-3">
                <div className="bg-indigo-100 p-3 rounded-lg shrink-0">
                  <Headphones className="h-6 w-6 text-indigo-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-slate-900 mb-1">{ab.title}</h3>
                  <p className="text-xs text-slate-400 mb-3">Publicado em {new Date(ab.uploaded_at).toLocaleDateString('pt-BR')}</p>
                  <video controls className="w-full rounded-lg" preload="metadata"
                    data-testid={`audiobook-player-${ab.audiobook_id}`}>
                    <source src={`${backendUrl}/api/audiobooks/stream/${ab.filename}`} type="video/mp4" />
                  </video>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    ) : (
      <Card className="bg-white border border-slate-200"><CardContent className="py-12 text-center">
        <Headphones className="h-12 w-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500">Nenhum audiobook disponivel ainda</p>
        <p className="text-xs text-slate-400 mt-1">Os conteudos serao publicados pelo administrador</p>
      </CardContent></Card>
    )}
  </div>
);
